/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function RatingFilled(props) {
  const { size, color, ...other } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height={size}
      width={size}
      title="rating-filled-ico"
      {...other}
    >
      <path
        d="M7.73301 20.829C7.48456 20.9587 7.20474 21.0162 6.92528 20.9949C6.64582 20.9737 6.3779 20.8746 6.15188 20.7089C5.92587 20.5431 5.75082 20.3174 5.64656 20.0573C5.5423 19.7971 5.51301 19.5129 5.56201 19.237L6.37101 14.6L2.96501 11.336C2.76098 11.1414 2.61592 10.8933 2.54646 10.6201C2.47699 10.3468 2.48594 10.0595 2.57227 9.79116C2.6586 9.52278 2.81882 9.28415 3.03455 9.10266C3.25029 8.92116 3.51281 8.80413 3.79201 8.765L8.52101 8.089L10.656 3.83C10.7801 3.5796 10.9717 3.36884 11.2092 3.2215C11.4466 3.07416 11.7205 2.99608 12 2.99608C12.2795 2.99608 12.5534 3.07416 12.7909 3.2215C13.0283 3.36884 13.2199 3.5796 13.344 3.83L15.479 8.089L20.208 8.765C20.4872 8.80413 20.7497 8.92116 20.9655 9.10266C21.1812 9.28415 21.3414 9.52278 21.4277 9.79116C21.5141 10.0595 21.523 10.3468 21.4536 10.6201C21.3841 10.8933 21.239 11.1414 21.035 11.336L17.629 14.6L18.438 19.238C18.487 19.514 18.4577 19.7981 18.3535 20.0583C18.2492 20.3184 18.0741 20.5441 17.8481 20.7099C17.6221 20.8756 17.3542 20.9747 17.0747 20.9959C16.7953 21.0172 16.5155 20.9597 16.267 20.83L12 18.625L7.73301 20.829Z"
        fill={color}
      />
    </svg>
  );
}

RatingFilled.defaultProps = {
  color: "currentColor",
  size: 24,
};

RatingFilled.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
